export default __webpack_public_path__ + "static/media/Logo.1cdb24e2.jpg";